import type {
  MerchantAppReturn,
  ReturnAddress,
} from "@redotech/redo-return-core-common/return";

export type UnlabeledGroup = NonNullable<
  MerchantAppReturn["shipmentGroups"]
>[number];

export function getUnlabeledGroups(
  return_: MerchantAppReturn,
): UnlabeledGroup[] {
  if (!return_.shipmentGroups?.length) {
    return [];
  }
  return return_.shipmentGroups.filter(
    (group) =>
      !return_.shipments?.find(
        (s) => s.shipmentGroupID === group.id && s._shipment?.postage_label,
      ),
  );
}

export function getProductsForGroup(
  return_: MerchantAppReturn,
  groupId: string,
) {
  return return_.products.filter(
    (product) =>
      product.shipmentGroupID === groupId ||
      product.shipmentGroupIDs?.includes(groupId),
  );
}

export function formatAddress(address?: ReturnAddress | null): {
  name: string;
  line1: string;
  line2: string;
} {
  if (!address) {
    return { name: "", line1: "", line2: "" };
  }
  const name = address.name || "";
  const line1 = address.address1 || "";
  const parts = [address.city, address.province, address.zip]
    .filter(Boolean)
    .join(", ");
  const line2 = parts
    ? `${parts}${address.country_code ? `, ${address.country_code}` : ""}`
    : "";
  return { name, line1, line2 };
}
